import React from 'react';
import { Invoice, invoiceTotal } from '../types';
import { exportInvoicePDF } from '../pdf';
import { Edit2, Trash2, FileText, DownloadCloud, UploadCloud } from 'lucide-react';

type Props = {
  invoices: Invoice[];
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  onImport: (list: Invoice[]) => void;
  selectedId?: string | null;
};

function downloadJSON(filename: string, data: unknown) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export default function InvoiceList({ invoices, onEdit, onDelete, onImport, selectedId }: Props) {
  function handleExportAll() {
    downloadJSON('invoices.json', invoices);
  }

  function handleImport(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const parsed = JSON.parse(String(reader.result)) as Invoice[];
        onImport(parsed);
      } catch (err) {
        alert('Invalid JSON file');
      }
    };
    reader.readAsText(file);
  }

  return (
    <div className="panel">
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <h3 style={{margin:0}}>Invoices</h3>
        <div className="invoice-controls">
          <button className="btn ghost" onClick={handleExportAll}><DownloadCloud size={16} style={{verticalAlign:'middle',marginRight:8}}/>Export</button>
          <label className="btn ghost" style={{cursor:'pointer'}}>
            <UploadCloud size={16} style={{verticalAlign:'middle',marginRight:8}}/>Import
            <input className="import-input" type="file" accept="application/json" onChange={handleImport} />
          </label>
        </div>
      </div>

      <div style={{marginTop:12}}>
        {invoices.length === 0 && <div className="muted">No invoices yet</div>}
        {invoices.map((inv) => (
          <div key={inv.id} className={"invoice-item" + (selectedId === inv.id ? ' selected' : '')} onClick={() => onEdit(inv.id)} style={{cursor:'pointer'}}>
            <div>
              <div><strong>{inv.customer}</strong></div>
              <div className="small muted">{inv.date} • {inv.items.length} items</div>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <div className="small">${invoiceTotal(inv).toFixed(2)}</div>
              <div className="invoice-controls">
                <button className="btn ghost" onClick={(e) => { e.stopPropagation(); onEdit(inv.id); }} aria-label="Edit invoice"><Edit2 size={14} style={{verticalAlign:'middle',marginRight:6}}/>Edit</button>
                <button className="btn" onClick={(e) => { e.stopPropagation(); onDelete(inv.id); }} aria-label="Delete invoice"><Trash2 size={14} style={{verticalAlign:'middle',marginRight:6}}/>Delete</button>
                <button className="btn ghost" onClick={(e) => { e.stopPropagation(); exportInvoicePDF(inv); }} aria-label="Download PDF"><DownloadCloud size={14} style={{verticalAlign:'middle',marginRight:6}}/>PDF</button>
                <button className="btn ghost" onClick={(e) => { e.stopPropagation(); downloadJSON(`invoice-${inv.id}.json`, inv); }} aria-label="Download JSON"><FileText size={14} style={{verticalAlign:'middle',marginRight:6}}/>JSON</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
